/**
 * Custom alt text for CPI formula images.
 * Key: formula URL filename (from manifestData.formula.url)
 *
 * TODO: Move to backend (formula.alt in /api/v3/cpis/:name/details response)
 */
export const formulaAltTextMap: Record<string, string> = {
  'cpi016_formula.svg':
    '{Mean~(Age~of~Open~Vulnerability)[Date]} : \\frac{Sum~(Days~[Severity]~Vulnerability~is~Open)}{Number~of~Open~[Severity]~Vulnerabilities}'
}
